import React from 'react';

const INLINE_FORMAT_PATTERN = /(\*\*[^*]+?\*\*|\*[^*]+?\*)/g;

const renderInlineText = (text, keyPrefix) => (
  String(text)
    .split(INLINE_FORMAT_PATTERN)
    .map((part, index) => {
      const key = `${keyPrefix}-${index}`;

      if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
        return <strong key={key}>{part.slice(2, -2)}</strong>;
      }

      if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
        return <em key={key}>{part.slice(1, -1)}</em>;
      }

      return part;
    })
);

export default function FormattedNewsText({
  as: Component = 'div',
  className = '',
  singleLine = false,
  text = '',
  ...props
}) {
  const normalizedText = String(text || '').replace(/\r\n?/g, '\n');

  if (singleLine) {
    return (
      <Component className={className} {...props}>
        {renderInlineText(normalizedText.replace(/\n+/g, ' '), 'single')}
      </Component>
    );
  }

  const lines = normalizedText.split('\n');

  return (
    <Component className={className} {...props}>
      {lines.map((line, index) => (
        <React.Fragment key={`line-${index}`}>
          {renderInlineText(line, `line-${index}`)}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </Component>
  );
}
